import { observer } from "mobx-react"
import * as React from 'react'
import { IntlProvider } from "react-intl"

export type IntlProviderWrapperProps = {
    languageSettings: { language: string }
    children: React.ReactNode
}

export const IntlProviderWrapper = observer(({languageSettings, children}: IntlProviderWrapperProps) => {
    const urlParams = new URLSearchParams(window.location.search)
    const queryLanguage = urlParams.get('language')
    const locale: string = languageSettings?.language
    const localePrefix = (locale === 'Svenska' || queryLanguage === 'Svenska' ) ? 'sv' : 'en' //sätter default till engelska
    const messages = require(`./translations/${localePrefix}`).default

    return (
        <IntlProvider messages={messages} locale={localePrefix}>
            {React.Children.only(children)}
        </IntlProvider>
    )
})
   